import React, { useState } from 'react';
import { MOCK_USERS } from '../constants/index';
import { UserRole } from '../types/index';
import { LogIn } from 'lucide-react';

/** Bloqueio de acesso para empregados entre as 22:00 e as 07:00. */
function isEmployeeAccessBlocked() {
  const hour = new Date().getHours();
  return hour >= 22 || hour < 7;
}

export default function LoginView({ onLogin, users = [] }) {
  const USE_MOCK_USERS = process.env.REACT_APP_USE_MOCK_USERS === 'true';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    // Em produção: NÃO fazer fallback para MOCK_USERS (evita "ressuscitar" utilizadores apagados).
    // Para desenvolvimento local, pode ativar REACT_APP_USE_MOCK_USERS=true.
    const usersList = users.length > 0 ? users : (USE_MOCK_USERS ? MOCK_USERS : []);
    const user = usersList.find(u => u.email === email && u.password === password);
    if (user) {
      if (user.role === UserRole.EMPLOYEE && isEmployeeAccessBlocked()) {
        setError('Acesso indisponível.');
        return;
      }
      onLogin(user);
    } else {
      setError(
        usersList.length === 0
          ? 'Não foi possível carregar utilizadores (ou não existem utilizadores configurados).'
          : 'Credenciais inválidas. Por favor, verifique o e-mail e palavra-passe.'
      );
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f1f8e9] p-6">
      <div className="bg-white p-10 rounded-[3rem] shadow-2xl w-full max-w-md border border-green-100">
        <div className="flex flex-col items-center mb-10">
          <div className="w-24 h-24 bg-[#1b5e20] rounded-3xl flex items-center justify-center mb-6 shadow-xl rotate-3">
            <LogIn className="text-white" size={48} />
          </div>
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight">Gestão Pro</h1>
          <p className="text-green-700 mt-2 font-bold text-lg">Área Interna Segura</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-widest">E-mail Corporativo</label>
            <input 
              type="email" 
              required
              className="w-full p-4 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-green-600 outline-none transition-all text-xl font-bold text-slate-900"
              placeholder="seu@email.pt"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-widest">Palavra-passe</label>
            <input 
              type="password" 
              required
              className="w-full p-4 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-green-600 outline-none transition-all text-xl font-bold text-slate-900"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          {error && <p className="text-red-600 text-sm font-bold bg-red-50 p-4 rounded-xl text-center">{error}</p>}
          <button 
            type="submit"
            className="w-full py-5 bg-[#1b5e20] text-white font-black rounded-2xl text-2xl hover:bg-green-900 shadow-xl transform active:scale-95 transition-all mt-4"
          >
            Entrar no Sistema
          </button>
        </form>
      </div>
    </div>
  );
}

